<template>
  <HorizontalCard
    large
    show-image
    show-tags
    v-if="documentData"
    :document-data="documentData"
    :show-evaluation="false"
    :allow-adding-to-reflection="true"
    :is-loading="isLoading"
  />
</template>

<script>
import HorizontalCard from '@/components/cards/documentCards/HorizontalCard';

export default {
  name: 'PortfolioCard',
  components: {
    HorizontalCard,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      documentData: undefined,
    };
  },
  created() {
    this.documentData = { ...this.item };
  },
  watch: {
    isLoading() {
      // Fix a bug where the old image and the old analysis elements are displayed.
      if (this.isLoading) {
        this.documentData.documentDetails.leadImageUrl = undefined;
      }
    },
    item() {
      this.documentData = { ...this.item };
    },
  },
};
</script>
